import {
    pasteOptionPasteAsIsTooltip,
    pasteOptionPasteTextTooltip,
} from './getButtons.locstring.json';
import loc from 'owa-localize';
import PasteOptionButton from '../store/schema/PasteOptionButton';

import { ControlIcons } from 'owa-control-icons';

export default function getButtons(): PasteOptionButton[] {
    return [
        {
            key: 'PASTE_ORIGINAL',
            title: loc(pasteOptionPasteAsIsTooltip),
            shortcut: 'P',
            icon: ControlIcons.Paste,
        },
        {
            key: 'PASTE_TEXT',
            title: loc(pasteOptionPasteTextTooltip),
            shortcut: 'T',
            icon: ControlIcons.PasteAsText,
        },
    ];
}
